import { FilterRuleDTO } from "../DTO/filterRuleDTO";
import { FieldDefinition } from "./fieldDefinition";
import { FilterField } from "./filterField";
import { FilterRuleDefinition } from "./filterRuleDefinition";

export class FilterRule{

    public id!: number;
    public inputFieldReference!: FilterField;
    public inputField!: FieldDefinition;
    public filterRuleDefinitionId!: number;
    public filterRuleDefinition!: FilterRuleDefinition;
    public filterParameter!: string;

    public createInputField(fieldDefinitions:FieldDefinition[]){
        if(this.inputFieldReference) {
            this.inputField = fieldDefinitions.find(f=>f.index==this.inputFieldReference.index)!;
        }
    }

    public static mapFromDTO(param:FilterRuleDTO):FilterRule{ 
        if (!param) throw new Error("parameter is null")
        let obj = new FilterRule();
        try
        {
            obj.id = param.id;
            if(param.inputFieldReference){
                obj.inputFieldReference = JSON.parse(param.inputFieldReference);
            } 
            obj.filterRuleDefinitionId = param.filterRuleDefinitionId;
            obj.filterParameter= param.filterParameter;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:FilterRule):FilterRuleDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new FilterRuleDTO();
        try
        {
            dto.id = param.id;
            if(param.inputField) dto.inputFieldReference = JSON.stringify(param.inputField.filterField);
            dto.filterRuleDefinitionId = param.filterRuleDefinition.id;
            dto.filterParameter= param.filterParameter;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}